import React from 'react';
import Header from '../../components/Layout/Header';
import './Department.css';

const SpareParts: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Spare Parts Department</h1>
          <p className="department-description">
            Welcome to the Spare Parts Department page. Here you can find information about 
            spare parts inventory, availability, and ordering resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About Spare Parts Department</h3>
            <p>
              The Spare Parts Department manages inventory, procurement, and distribution of 
              spare parts and components to support service operations and customer needs.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Inventory Management</li>
              <li>Parts Procurement</li>
              <li>Stock Control</li>
              <li>Parts Distribution</li>
              <li>Quality Control</li>
              <li>Supplier Management</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For spare parts inquiries, please contact the Spare Parts Department.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpareParts;

